/*
* Dynamic Product Description Tabs
* Splits product description by <u> tags and creates tabs dynamically
*/

document.addEventListener('DOMContentLoaded', (event) => {
    // Switch to vertical accordion layout
    const tabList = document.querySelector('.productView-tab .tabs');
    const tabContents = document.querySelector('.tabs-contents');

    if (tabList) tabList.style.display = 'none';
    if (tabContents) {
        tabContents.classList.remove('tabs-contents-horizontal');
        tabContents.classList.add('tabs-contents-vertical');
    }

    // Try to select by ID (if user added it) or fallback to the known class structure
    const descriptionContainer = document.getElementById('product-description-content') ||
        document.querySelector('.product-description-tab .toggle-content') ||
        document.getElementById('tab-description-mobile');

    if (descriptionContainer) {
        const rawContent = descriptionContainer.innerHTML;
        console.log('Product Description Raw Content:', rawContent);

        // Split by <u> tags or <span style="text-decoration: underline;"> tags
        // Regex logic: Match <u>...</u> OR <span ... style="...text-decoration: underline...">...</span>
        const parts = rawContent.split(/(<u\b[^>]*>.*?<\/u>|<span\b[^>]*style="[^"]*text-decoration:\s*underline[^"]*"[^>]*>.*?<\/span>)/i);

        if (parts.length > 1) {
            const tabsContainer = document.querySelector('.productView-tab .tabs');
            const contentsContainer = document.querySelector('.productView-tab .tabs-contents');

            // The first part is the main description
            let mainDescription = parts[0];
            descriptionContainer.innerHTML = mainDescription;

            for (let i = 1; i < parts.length; i += 2) {
                let titleHtml = parts[i];
                let contentHtml = parts[i + 1];

                if (!titleHtml || !contentHtml) continue;

                // Strip tags from title to get plain text
                let titleText = titleHtml.replace(/<[^>]*>/g, '').trim();
                let tabId = 'tab-' + titleText.toLowerCase().replace(/[^a-z0-9]+/g, '-');

                // 1. Create Tab Title Item
                if (tabsContainer) {
                    const newTabLi = document.createElement('li');
                    newTabLi.className = 'tab';
                    newTabLi.innerHTML = `<a class="tab-title" href="#${tabId}">${titleText}</a>`;
                    tabsContainer.appendChild(newTabLi);

                    const newLink = newTabLi.querySelector('a');
                    newLink.addEventListener('click', function (e) {
                        e.preventDefault();
                        document.querySelectorAll('.productView-tab .tab-title').forEach(el => el.classList.remove('is-open'));
                        document.querySelectorAll('.productView-tab .tab-content').forEach(el => el.classList.remove('is-active'));
                        this.classList.add('is-open');
                        const targetId = this.getAttribute('href').substring(1);
                        document.getElementById(targetId)?.classList.add('is-active');
                    });
                }

                // 2. Create Tab Content Div
                if (contentsContainer) {
                    const newContentDiv = document.createElement('div');
                    newContentDiv.className = 'tab-content';
                    newContentDiv.id = tabId;

                    newContentDiv.innerHTML = `
                        <div class="toggle-title">
                            <a class="toggleLink" data-collapsible href="#${tabId}-mobile">
                                <span class="text">${titleText}</span>
                                <span class="icon-plus">&nbsp;</span>
                            </a>
                        </div>
                        <div class="toggle-content" id="${tabId}-mobile">
                            ${contentHtml}
                        </div>
                    `;
                    contentsContainer.appendChild(newContentDiv);

                    const toggleLink = newContentDiv.querySelector('.toggleLink');
                    toggleLink.addEventListener('click', function (e) {
                        e.preventDefault();
                        this.classList.toggle('is-open');
                        const content = this.closest('.tab-content').querySelector('.toggle-content');
                        if (content.style.display === 'block') {
                            content.style.display = 'none';
                        } else {
                            content.style.display = 'block';
                        }
                    });
                }
            }
        }
    } else {
        console.warn('Product description container not found');
    }
});
